import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Inject, inject, OnInit, signal, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { HttpStatusCode } from 'axios';
import { DashboardManagerTeamServiceV2 } from '../../dashboard-services/dashboard-manager-team/dashboard-manager-team-v2.service';
import { SubmissionApeByAdvisorsV2 } from '../../dashboard-interfaces/submission-ape-by-advisors-v2.interface';

@Component({
  selector: 'app-view-submission-ape-manager-advisors-v2',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    ReactiveFormsModule,
    MatDividerModule
  ],
  templateUrl: './view-submission-ape-manager-advisors-v2.dialog.html',
  styleUrl: './view-submission-ape-manager-advisors-v2.dialog.scss'
})
export class ViewSubmissionApeManagerAdvisorsDialogV2 implements OnInit, AfterViewInit {
  private router = inject(Router);
  private snackBarService = inject(SnackbarService);
  private dashboardManagerTeamService = inject(DashboardManagerTeamServiceV2);

  private submissionApeByAdvisorData: SubmissionApeByAdvisorsV2[] = [];
  protected submissionApeByAdvisorTableDisplayDataRow: string[] = ["repCode", "personName", "monthSubmissionSinglife", "monthSubmissionSinglifeCase", "yearSubmissionSinglife", "yearSubmissionSinglifeCase", "yearPendingSinglife", "yearPendingSinglifeCase"];
  protected submissionApeByAdvisorTableDisplayFirstColumn: string[] = ['repCode', 'personName', 'header-row2-month-singlife-group', 'header-row2-year-singlife-group', 'header-row2-year-pendinglife-group'];
  protected submissionApeByAdvisorTableDisplaySecondColumn: string[] = ['monthSubmissionSinglife', 'monthSubmissionSinglifeCase', 'yearSubmissionSinglife', 'yearSubmissionSinglifeCase', 'yearPendingSinglife', 'yearPendingSinglifeCase'];
  protected submissionApeByAdvisorTableDataSource = new MatTableDataSource<SubmissionApeByAdvisorsV2>();

  submissionApeBranchAdvisorTableFilterFc = new FormControl("");

  @ViewChild('submissionApeByAdvisorTablePaginator')
  submissionApeByAdvisorTablePaginator!: MatPaginator;
  @ViewChild('submissionApeByAdvisorTableSort')
  submissionApeByAdvisorTableSort = new MatSort();

  protected managerRepCode: string = "";
  protected managerName: string = "";
  protected targetYear: string = "";

  protected setSprinner = signal(false);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public matData: any
  ) { }

  async ngOnInit(): Promise<void> {
    this.managerRepCode = this.matData.managerRepCode;
    this.managerName = this.matData.managerName;
    this.targetYear = this.matData.targetYear;

    await this.getDashboardDataByBranchAdvisors(this.managerRepCode, this.targetYear);

    this.submissionApeByAdvisorTableDataSource.data = this.submissionApeByAdvisorData;
  }

  ngAfterViewInit(): void {
    this.submissionApeByAdvisorTableDataSource.paginator = this.submissionApeByAdvisorTablePaginator;
    this.submissionApeByAdvisorTableDataSource.sort = this.submissionApeByAdvisorTableSort;
  }

  private async getDashboardDataByBranchAdvisors(managerRepCode: string, targetYear: string) {
    this.setSprinner.set(true);

    const responseData = await this.dashboardManagerTeamService
      .getAgentsByPiasId(managerRepCode, Number.parseInt(targetYear))
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      const advisorData: any[] = responseData.data.responsedata;
      advisorData.forEach((advisorItem) => {
        this.submissionApeByAdvisorData.push({
          repCode: advisorItem.piasRepCode.toString(),
          personName: advisorItem.agentRealName.toString() || advisorItem.agentPreferredName.toString(),
          branch: advisorItem.branch.toString(),
          monthSubmissionSinglife: Number.parseInt(advisorItem.mtdSubmissionSinglife.toString()),
          monthSubmissionSinglifeCase: Number.parseInt(advisorItem.mtdSubmissionSinglifeCase.toString()),
          yearSubmissionSinglife: Number.parseInt(advisorItem.ytdSubmissionSinglife.toString()),
          yearSubmissionSinglifeCase: Number.parseInt(advisorItem.ytdSubmissionSinglifeCase.toString()),
          yearPendingSinglife: Number.parseInt(advisorItem.ytdPendingSinglife.toString()),
          yearPendingSinglifeCase: Number.parseInt(advisorItem.ytdPendingSinglifeCase.toString()),
          yearTarget: 0,
          // yearTotal: (Number.parseInt(advisorItem.ytdSubmissionSinglife.toString()) + Number.parseInt(advisorItem.mtdNonSinglife.toString())),
          userGroup: advisorItem.userGroup.toString()
        });
      });

      // this.inceptedApeByAdvisorData = this.inceptedApeByAdvisorData.filter(item => item.userGroup !== 'Affinity');
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  protected clearSearchField() {
    this.submissionApeBranchAdvisorTableFilterFc.setValue('');
    this.__applySubmissionApeBranchAdvisorsDataFilter();
  }

  protected __applySubmissionApeBranchAdvisorsDataFilter() {
    let filterValue: string = this.submissionApeBranchAdvisorTableFilterFc.value?.toString() || '';

    let tempSubmissionApeByAdvisorTableData: SubmissionApeByAdvisorsV2[] = [];

    if (filterValue) {
      tempSubmissionApeByAdvisorTableData = this.submissionApeByAdvisorData.filter(apeData =>
        apeData.repCode.toString().includes(filterValue)
        || apeData.personName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempSubmissionApeByAdvisorTableData = this.submissionApeByAdvisorData;
    }

    this.submissionApeByAdvisorTableDataSource.data = tempSubmissionApeByAdvisorTableData;
  }

}
